import PartsListPage from './list';
import PartPage from './view';

export default PartPage;
export { PartsListPage };
